import { Link } from "react-router-dom";
import { Camera, Images, Lock } from "lucide-react";
import { getUploadWindow } from "@/lib/uploadWindow";

// Upload-only: guests drop photos/videos here but never see what anyone else
// uploaded -- the organizer moderates everything in the dashboard first, then
// decides if/when to publish a curated album at its own separate link.
export default function Gallery({ wedding, onOpenUpload }) {
  const { uploadsOpen, windowOpensAt } = getUploadWindow(wedding);

  return (
    <section className="py-16 sm:py-20 px-6 sm:px-12 max-w-2xl mx-auto text-center" data-testid="gallery-section">
      <Camera size={28} className="mx-auto mb-4" style={{ color: "var(--wed-primary)" }} />
      <p className="eyebrow mb-3">Galleria condivisa</p>
      <h2 className="font-wed text-3xl sm:text-4xl mb-3">Condividi i tuoi scatti</h2>
      <p className="text-neutral-500 mb-8 text-sm">
        {uploadsOpen
          ? "Carica le tue foto e i tuoi video del grande giorno — gli sposi li raccoglieranno e, quando vorranno, pubblicheranno un album con tutti gli scatti."
          : `Potrai caricare le tue foto a partire dal ${windowOpensAt.toLocaleDateString("it-IT", { day: "numeric", month: "long" })}.`}
      </p>

      <div className="flex items-center justify-center gap-3 flex-wrap">
        {uploadsOpen ? (
          <button className="btn-wed inline-flex items-center gap-2" onClick={onOpenUpload} data-testid="gallery-upload-button">
            <Camera size={18} /> Carica foto/video
          </button>
        ) : (
          <button className="btn-outline-wed inline-flex items-center gap-2 opacity-60 cursor-not-allowed" disabled data-testid="gallery-upload-locked">
            <Lock size={16} /> Apre il {windowOpensAt.toLocaleDateString("it-IT", { day: "numeric", month: "long" })}
          </button>
        )}
        {/* Always linked, even before publication -- the album page itself shows
            a "not published yet" state, so there's nothing to hide by waiting. */}
        <Link to={`/${wedding.slug}/album`} className="btn-outline-wed inline-flex items-center gap-2" data-testid="gallery-album-link">
          <Images size={18} /> Vedi l'album
        </Link>
      </div>
    </section>
  );
}
